module.exports = __webpack_public_path__ + "img/food4.c587cde6.png";